<script lang="ts">
    import {
        onMount,
    } from "svelte";
    import type { ToolBoxManager } from "./ToolBoxManager";

    export let manager: ToolBoxManager<string>;

    // define variables.
    let controlRoot: HTMLElement;

    onMount(async () => {
        await manager.initialize(controlRoot);

        // onMapLoad();
    });

    // async function onMapLoad() {
    //     // const map: Map = scenarioManager.getMap();
    //     // if (typeof controlRoot !== "undefined" && typeof map !== "undefined") {
    //     //     map.addControl(manager, options.position);
    //     // }
    // }
</script>

<div class="maplibregl-ctrl maplibregl-ctrl-group" bind:this={controlRoot}>
    <slot />
</div>

<style>
    .maplibregl-ctrl-group {
        background-color: rgba(0, 0, 0, 0.5);
        width: 40px;
        margin-right: 0px;
        box-shadow: unset;
        border-radius: 4px 0 0 4px;
    }

    :global(.btn-toolbox) {
        padding: unset;
        width: 40px;
        height: 40px;
        text-align: unset;
        border-radius: 4px 0 0 0;
    }

    :global(.btn-toolbox:last-child) {
        border-radius: 0 0 0 4px;
    }

    :global(.toolbox-icon) {
        margin-left: 10px;
        margin-top: 10px;
        width: 20px;
        height: 20px;
    }

    :global(.btn-toolbox.active) {
        background-color: #ffc926;
    }
</style>
